import { render, staticRenderFns } from "./HistoryMenu.vue?vue&type=template&id=aba2b63a&scoped=true&"
import script from "./HistoryMenu.vue?vue&type=script&lang=ts&"
export * from "./HistoryMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryMenu.vue?vue&type=style&index=0&id=aba2b63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba2b63a",
  null
  
)

export default component.exports